import GenerationConfigs from './GenerationConfigs';

export default GenerationConfigs;
